/* TWS product page: gallery sync, sticky bar, popup suppression. */
(function () {
  function initGallery(root) {
    var gallery = root.querySelector('[data-tws-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-tws-track]');
    var slides = Array.prototype.slice.call(track.querySelectorAll('.tws-pdp__slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-tws-thumb]'));
    var counter = gallery.querySelector('[data-tws-current]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    var horizontal = slides.length > 1 && track.scrollWidth > track.clientWidth + 4;
    var headClone = null, tailClone = null;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        if (n === i) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = String(i + 1);
      /* Keep the active thumbnail in view in the side rail / strip */
      var t = thumbs[i];
      if (t && t.parentNode.scrollHeight > t.parentNode.clientHeight + 2) {
        t.parentNode.scrollTo({ top: t.offsetTop - t.parentNode.offsetTop - 8, behavior: reduce ? 'auto' : 'smooth' });
      }
    }

    /* Distance from the track's start edge to an element; works left-to-right and right-to-left. */
    function delta(el) {
      return el.getBoundingClientRect().left - track.getBoundingClientRect().left;
    }
    function scrollToEl(el, smooth) {
      if (!smooth) {
        track.style.scrollSnapType = 'none';
        track.scrollLeft += delta(el);
        void track.offsetWidth;
        track.style.scrollSnapType = '';
        return;
      }
      track.scrollBy({ left: delta(el), behavior: reduce ? 'auto' : 'smooth' });
    }

    function goTo(i, dir) {
      var target = slides[i];
      if (!target) return;
      if (horizontal) {
        if (dir === 1 && i === 0 && current === slides.length - 1) target = tailClone;
        else if (dir === -1 && i === slides.length - 1 && current === 0) target = headClone;
        scrollToEl(target, true);
      } else {
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
      setActive(i);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-tws-thumb'), 10), 0);
      });
    });

    /* Prev/next arrows sit on a wrapper around the track so they centre on the image, not the thumbnails. */
    if (slides.length > 1) {
      var stage = document.createElement('div');
      stage.className = 'tws-pdp__stage';
      track.parentNode.insertBefore(stage, track);
      stage.appendChild(track);
      function arrow(dir, label, path) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tws-pdp__nav tws-pdp__nav--' + dir;
        b.setAttribute('aria-label', label);
        b.innerHTML = '<svg class="tws-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="' + path + '"/></svg>';
        stage.appendChild(b);
        return b;
      }
      var prev = arrow('prev', 'Previous image', 'm14.5 6-6 6 6 6');
      var next = arrow('next', 'Next image', 'm9.5 6 6 6-6 6');
      prev.addEventListener('click', function () { goTo((current - 1 + slides.length) % slides.length, -1); });
      next.addEventListener('click', function () { goTo((current + 1) % slides.length, 1); });
      setActive(0);
    }

    /* Infinite loop: a copy of the last image sits before the first and a copy of the first after the last.
       Going past either end slides onto the copy with the normal motion, then jumps (invisibly) to the real
       image, so the gallery always moves forward instead of rewinding. */
    if (horizontal) {
      function makeClone(src) {
        var c = src.cloneNode(true);
        c.classList.add('is-clone');
        c.removeAttribute('id');
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('inert', '');
        c.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
        c.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
        return c;
      }
      headClone = makeClone(slides[slides.length - 1]);
      tailClone = makeClone(slides[0]);
      track.insertBefore(headClone, slides[0]);
      track.appendChild(tailClone);
      /* Park on the real first image (again once images have their size), only then start correcting at the ends. */
      var ready = false;
      function home() { scrollToEl(slides[current], false); }
      home();
      requestAnimationFrame(function () { home(); requestAnimationFrame(function () { home(); ready = true; }); });
      window.addEventListener('load', home);
      window.addEventListener('resize', home);

      var settleTimer;
      function settle() {
        if (!ready) return;
        var all = [headClone].concat(slides, [tailClone]);
        var nearest = all.reduce(function (best, el) { return Math.abs(delta(el)) < Math.abs(delta(best)) ? el : best; }, all[0]);
        if (nearest === tailClone) { scrollToEl(slides[0], false); setActive(0); }
        else if (nearest === headClone) { scrollToEl(slides[slides.length - 1], false); setActive(slides.length - 1); }
      }
      if ('onscrollend' in window) track.addEventListener('scrollend', settle);
      track.addEventListener('scroll', function () { clearTimeout(settleTimer); settleTimer = setTimeout(settle, 140); }, { passive: true });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6 && !e.target.classList.contains('is-clone')) setActive(parseInt(e.target.getAttribute('data-index'), 10) || 0);
        });
      }, { root: null, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-tws-sticky]');
    var ctas = root.querySelector('[data-tws-ctas]');
    if (!bar || !ctas || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var footer = document.querySelector('footer, .footer');
    var ctasVisible = true;
    var footerVisible = false;
    function update() {
      var drawerOpen = document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile');
      var on = !ctasVisible && !footerVisible && !drawerOpen;
      bar.classList.toggle('is-visible', on);
      document.documentElement.classList.toggle('tws-pdp-sticky-on', on);
    }
    new IntersectionObserver(function (e) {
      ctasVisible = e[0].isIntersecting || e[0].boundingClientRect.top > 0;
      update();
    }).observe(ctas);
    if (footer) {
      new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; update(); }).observe(footer);
    }
    new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function initEta(root) {
    var el = root.querySelector('[data-tws-eta]');
    if (!el) return;
    // data-days counts working days (Mon–Fri, the UAE weekend is Sat–Sun), to match the checkout's delivery time.
    var left = parseInt(el.getAttribute('data-days'), 10) || 2;
    var d = new Date();
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) left--;
    }
    el.querySelector('[data-tws-eta-date]').textContent = d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
    el.hidden = false;
  }

  function quietPage(root) {
    if (!root.classList.contains('tws-pdp--quiet')) return;
    document.documentElement.classList.add('tws-pdp-quiet');
  }

  function init() {
    document.querySelectorAll('[data-tws-pdp]').forEach(function (root) {
      quietPage(root);
      initGallery(root);
      initSticky(root);
      initEta(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
